<template>
  <v-app id="stormport-assets">
    <v-snackbar
      v-model="snackbar.active"
      top
      right
      :color="snackbar.color"
      :timeout="snackbar.timeout"
    >
      <div v-html="snackbar.text" />
    </v-snackbar>

    <v-overlay :opacity="0.8" :z-index="999" :value="loading">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>

    <v-app-bar app clipped-left>
      <v-toolbar-title>
        <v-icon>{{ $store.getters['Busy/ajaxIsLoading'] ? "mdi-loading mdi-spin" : "mdi-circle" }}</v-icon>
        {{ appName }}
      </v-toolbar-title>
      <div class="flex-grow-1 d-flex justify-space-between ml-2">
        <div v-if="hasContractsAvailable" class="d-flex align-center">
          <v-btn
            text
            :to="link.to"
            :href="link.href"
            v-for="(link, index) in links"
            :key="index"
          >
            {{ link.name }}
          </v-btn>
          <v-btn v-if="user.isAdmin" text :to="{ name: 'contracts-users' }">SYSTEM</v-btn>
        </div>
        <!-- This div just to ensure right links stay right if no left links -->
        <div v-else class="d-flex"></div>
        <div class="d-flex align-center">
          <v-menu offset-y left v-if="$store.state.contracts.contracts.length > 1">
            <template v-slot:activator="{ on, attrs }">
              <v-btn text v-bind="attrs" v-on="on">
                <span v-if="$store.getters['contracts/selected']">{{ $store.getters['contracts/selected'].name }}</span>
                <span v-else>Contracts</span>
                <v-icon
                  right
                  dark
                >
                  mdi-chevron-down
                </v-icon>
              </v-btn>
            </template>

            <v-list nav dense>
              <v-list-item-group v-model="selectedContractId">
                <template v-for="contract in $store.state.contracts.contracts">
                  <v-list-item
                    v-if="contract.id != selectedContractId"
                    :key="`contract_${contract.id}`"
                    @click="onSwitchContract(contract)"
                    :value="contract.id">
                    <v-list-item-title>{{ contract.name }}</v-list-item-title>
                  </v-list-item>
                </template>
              </v-list-item-group>
            </v-list>
          </v-menu>
          <v-btn text :to="{ name: 'profile' }" :disabled="!hasContractsAvailable">
            {{ user.name }}
          </v-btn>
          <v-btn text @click="logout">
            EXIT
          </v-btn>
        </div>
      </div>
      <!-- <v-tabs align-with-title>
        <v-tab
          v-for="(link, index) in links"
          :key="index"
          :to="link.to"
          :href="link.href"
        >
          {{ link.name }}
        </v-tab>
        <v-tab>
          <v-menu open-on-hover offset-y>
            <template v-slot:activator="{ on, attrs }">
              <div
                class="d-flex align-center"
                style="height: 100%; width: 100%"
                color="primary"
                dark
                v-bind="attrs"
                v-on="on"
              >
                SYSTEM
              </div>
            </template>

            <v-list>
              <v-list-item :to="{ name: 'config' }">
                <v-list-item-title>CONFIG</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </v-tab>
      </v-tabs>
      <v-spacer />
      <v-menu offset-y>
        <template v-slot:activator="{ on, attrs }">
          <span v-bind="attrs" v-on="on">
            {{ user.name || "" }} <v-icon>mdi-menu-down</v-icon>
          </span>
        </template>
        <v-list>
          <v-list-item @click="logout">
            <v-list-item-title>LOGOUT</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu> -->
    </v-app-bar>
    <v-content>
      <v-container fluid style="height: 100%">
        <geolocation-simulator v-if="geoSimulatorEnabled"></geolocation-simulator>
        <router-view />
      </v-container>
    </v-content>

    <v-footer padless>
      <v-col class="text-center" cols="12">
        &copy; {{ copyrightYear }}
      </v-col>
    </v-footer>
  </v-app>
</template>

<script>
import { mapState } from "vuex";
import { UserService } from "@/services/user.service";
import { denormalize } from "@/helpers/JsonApiDenormalizer";
import GeolocationSimulator from "@/components/GeolocationSimulator.vue";

export default {
  components: {
    GeolocationSimulator,
  },
  props: {
    source: String
  },
  data: () => ({
    copyrightYear: null,
    selectedContractId: null,
    links: [
      {
        name: "Missions",
        to: { name: "missions" }
      },
      {
        name: "Assets",
        to: { name: "assets" }
      },
      // Removing these links as per instructions:
      // See: https://trello.com/c/kt4Egkd5/1628
      /*
      {
        name: "Mapbox",
        to: { name: "assets-mapbox" }
      },
      {
        name: "Help",
        href: process.env.VUE_APP_SERVICE_STATION_UI_URL
      }
      */
    ]
  }),
  computed: {
    ...mapState({
      loading: state => state.loading,
      snackbar: state => state.snackbar,
      user: state => state.auth.user,
    }),
    appName() {
      return process.env.VUE_APP_NAME;
    },
    geoSimulatorEnabled() {
      // Show geo simulator button if on mission index or if
      // we can detect that the user has used it already.
      // (also limited to non-production environments)
      if (
          (
            window.origin.indexOf('localhost') !== -1
            ||
            window.origin.indexOf('stormport-beta' !== -1)
          )
          && (this.$route.name == 'config' || typeof window.geolocate !== 'undefined')
        ) {
        return true;
      }
      return false;
    },
    hasContractsAvailable() {
      return this.$store.state.contracts.contracts.length >= 1;
    },
  },
  watch: {
    "$store.state.auth.user": {
      deep: true,
      handler: function(nextUser) {
        this.ensureContract();
      }
    },
    "$store.state.contracts.selected_contract_id"(next, prev) {
      console.log(`Contract ID for context changed from ${prev} to ${next}`);
    },
  },
  created() {
    this.$vuetify.theme.dark = true;
    this.copyrightYear = (new Date).getFullYear();
  },
  mounted() {
    this.ensureContract();
  },
  methods: {
    logout() {
      this.$auth.logout({
        returnTo: `${process.env.VUE_APP_STORMPORT_UI_URL}/login`,
      });
    },
    async loadContracts() {
      try {
        const contracts = await this.$store.dispatch('contracts/fetchContracts');
        return contracts;
      }
      catch(err) {
        window.console && console.log(err);
      }
    },
    async switchContract(contract_id) {
      const user_id = this.$store.state.auth.user.id;
      const updatedUser = await UserService.switchContract(user_id, contract_id).then(res => denormalize(res.data));
      const contract = this.$store.state.contracts.contracts.find(c => {
        return c.id == updatedUser.contract_id;
      });
      if (contract) {
        this.$store.dispatch('contracts/selectContract', contract);
        this.$store.commit("snacktime", {
          text: `Active contract set to "${contract.name}".`,
        });
        // 2021-07-31
        // Send back to application start instead of simply reloading.
        // (avoids checking if current page is valid for contract)
        const nextLocation = this.$router.resolve({ path: '/' });
        const next_path = nextLocation.route.fullPath;
        if (next_path == window.location.pathname) {
          window.location.reload();
        }
        else {
          window.location.href = next_path;
        }
      }
      return updatedUser;
    },
    ensureContract: function () {
      return new Promise((resolve, reject) => {
        this.loadContracts().then(contracts => {
          if ( ! contracts || ! contracts.length) {
            if (this.$route.name !== 'errors.account_configuration') {
              this.$router.push({ name: 'errors.account_configuration' });
              resolve([]);
            }
          }
          let vuex_contract_id = this.$store.state.contracts.selected_contract_id;
          let user_contract_id = this.$store.state.auth.user.contract_id;
          if (user_contract_id && ! vuex_contract_id) {
            this.$store.dispatch('contracts/selectContract', user_contract_id);
          }
          let selectedContract = contracts.find(c => {
            return c.id == user_contract_id;
          });
          if (contracts.length > 0 && ! selectedContract) {
            this.switchContract(contracts[0].id).then(user => {
              user_contract_id = user.contract_id;
              selectedContract = contracts.find(c => {
                return c.id == user_contract_id;
              });
              this.$store.commit('config/setConfig', selectedContract);
              this.selectedContractId = selectedContract.id;
              resolve(selectedContract);
            });
          }
          else if (contracts.length > 0 && selectedContract) {
            this.$store.commit('config/setConfig', selectedContract);
            this.selectedContractId = selectedContract.id;
            resolve(selectedContract);
          }
          else return reject(new Error('No contract available to select from.'));
        })
        .catch(err => {
          this.$store.commit("snacktime", {
            text: err.message,
            color: 'error',
          });
          reject(err);
        });
      });
    },
    onSwitchContract(contract) {
      this.$store.commit('startLoading');
      this.switchContract(contract.id)
        .catch(err => {
          console.log(err);
        })
        .finally(() => {
          this.$store.commit('endLoading');
        });
    },
  }
};
</script>

<style lang="scss">
.v-tooltip__content { max-width: 500px; }
.v-app-bar {
  .v-tabs {
    width: 0;
  }
}
</style>
